import type { AgencyCategory, AgencyFormTab } from '@saaga/shared/interfaces/agencies.interface'
import type { ReactNode } from 'react'
import { useState } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { Form } from '@/components/ui/form'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'

import type { AgencyFormSchemaType } from './agency-form.schema'
import { AgencyFormTabsContent } from './agency-form-tabs-content.molecule'

interface AgencyFormProps {
  form: UseFormReturn<AgencyFormSchemaType>
  categoryList: AgencyCategory[]
  logoPreviewUrl: string | null
  onLogoChange: (file: File | null) => void
  onLogoRemove: () => void
  isDisabled?: boolean
  agencySlug?: string
  className?: string
}

export const AgencyForm = ({
  form,
  categoryList,
  logoPreviewUrl,
  onLogoChange,
  onLogoRemove,
  isDisabled = false,
  agencySlug,
  className,
}: AgencyFormProps): ReactNode => {
  const [activeTab, setActiveTab] = useState<AgencyFormTab>('presentation')

  return (
    <Form {...form}>
      <div className={cn('agency-form flex h-full min-h-0 flex-col overflow-hidden', className)}>
        <Tabs
          value={activeTab}
          onValueChange={(value) => setActiveTab(value as AgencyFormTab)}
          className="agency-form-tabs flex h-full min-h-0 flex-col overflow-hidden"
        >
          <div className="agency-form-tabs-header shrink-0 border-b px-4 py-3">
            <TabsList className="agency-form-tabs-list">
              <TabsTrigger value="presentation" className="agency-form-tab-presentation">
                Presentation
              </TabsTrigger>
              <TabsTrigger value="system" className="agency-form-tab-system">
                System
              </TabsTrigger>
              <TabsTrigger value="templates" className="agency-form-tab-templates">
                Prompt Templates
              </TabsTrigger>
            </TabsList>
          </div>
          <AgencyFormTabsContent
            form={form}
            categoryList={categoryList}
            logoPreviewUrl={logoPreviewUrl}
            onLogoChange={onLogoChange}
            onLogoRemove={onLogoRemove}
            isDisabled={isDisabled}
            agencySlug={agencySlug}
          />
        </Tabs>
      </div>
    </Form>
  )
}

AgencyForm.displayName = 'AgencyForm'
